module.exports = __webpack_public_path__ + "img/HeaderSecciones2.6f2754a4.png";